<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t('Flight-Reservation-List') }} </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-flex>
        <v-container fluid grid-list-sm>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs12 sm4 md2>
                <tarihim
                  :etiket="'Kayıt Baslangic Tarihi'"
                  :detaygizle="false"
                  v-model="searchParams.InsertStartDate"
                  v-bind:defaultvalue="'ok'"
                  :rules="[(v) => !!v || $t('Mandatory-section')]"
                >
                </tarihim>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <tarihim
                  :etiket="'Kayıt Bitiş Tarihi'"
                  :detaygizle="false"
                  v-model="searchParams.InsertEndDate"
                  v-bind:defaultvalue="'ok'"
                  :rules="[(v) => !!v || $t('Mandatory-section')]"
                >
                </tarihim>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <tarihim
                  :etiket="'Opsiyon Başlangıç'"
                  :detaygizle="false"
                  v-model="searchParams.InsertStartDate"
                  v-bind:defaultvalue="'ok'"
                  :rules="[(v) => !!v || $t('Mandatory-section')]"
                >
                </tarihim>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <tarihim
                  :etiket="'Opsiyon Bitiş'"
                  :detaygizle="false"
                  v-model="searchParams.InsertEndDate"
                  v-bind:defaultvalue="'ok'"
                  :rules="[(v) => !!v || $t('Mandatory-section')]"
                >
                </tarihim>
              </v-flex>
              <v-flex xs12 sm4 md3>
                <v-select
                  :label="$t('Process-Type')"
                  v-model="searchParams.Status"
                  :items="statusItems"
                  item-text="text"
                  item-value="value"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm4 md1>
                <v-btn fab small icon color="primary"  @click="getList()">
                  <v-icon>search</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <!--listeleme-->
          <v-flex
            pb-3
            xs12
            sm12
            md12
            v-for="item in ticketList"
            v-bind:key="item.DocumentNumber"
          >
            <v-hover>
              <v-card
                width="100%"
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`"
                class="elevation-1 pt-3 pl-3 pb-3"
              >
                <v-layout row wrap align-center justify-end>
                  <v-flex xs12 sm6 md1>
                    <v-flex
                      xs12
                      sm12
                      md12
                      class="font-weight-medium grey--text subheading"
                      style="color: #67768f"
                    >
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                          <v-img
                            :src="getImgUrl(item.Provider)"
                            height="80%"
                            width="80%"
                            contain
                          >
                          </v-img>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12 sm6 md2>
                    <v-layout row wrap>
                      <v-flex
                        xs12
                        sm12
                        md12
                        class="font-weight-medium grey--text subheading"
                        style="color: #67768f"
                      >
                        {{ item.Pnr }}
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md12
                        class="font-weight-medium grey--text subheading"
                        style="color: #67768f"
                      >
                        {{ item.DocumentNumber }}
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md12
                        class="
                          font-weight-medium
                          text-align-bottom
                          grey--text
                          body-1
                          pb-0
                          mb-0
                        "
                      >
                        {{ item.FirstName }} {{ item.LastName }}
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm6 md2>
                    <v-layout row wrap>
                      <v-flex
                        xs12
                        sm12
                        md12
                        class="font-weight-large grey--text caption"
                        ><span style="color: #67768f">{{ $t('Departure') }} :</span>
                        {{ item.DepartureDate.substring(0, 10) }}
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md12
                        class="font-weight-large grey--text caption"
                        ><span style="color: #67768f">{{ $t('Option') }} :</span>
                        {{ item.PrebookedAt }}
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm6 md2>
                    <v-layout row wrap>
                      <v-flex
                        xs12
                        sm12
                        md12
                        class="font-weight-medium grey--text caption"
                      >
                        {{ item.Origin }}
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md12
                        class="font-weight-medium grey--text caption"
                      >
                        {{ item.Destination }}
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm6 md2>
                    <v-flex
                      xs12
                      sm12
                      md12
                      class="font-weight-large grey--text caption"
                      ><span style="color: #67768f">Toplam Vergi:</span>
                      {{ item.TotalTax }}
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md12
                      class="font-weight-large grey--text caption"
                      ><span style="color: #67768f"> Toplam Servis:</span>
                      {{ item.TotalServiceFee | moneyformat }}
                    </v-flex>
                  </v-flex>

                  <v-flex xs12 sm6 md2>
                    <v-flex
                      xs12
                      sm12
                      md12
                      class="font-weight-large grey--text caption"
                      ><span style="color: #67768f"> {{ $t('totalamount') }} :</span>
                      {{ item.TotalFare | moneyformat }}
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md12
                      class="font-weight-large grey--text caption"
                      ><span style="color: #67768f"> {{ $t('Option') }} :</span>
                      {{ item.BaseFare | moneyformat }}
                    </v-flex>
                  </v-flex>

                  <v-flex xs12 sm6 md1>
                    <v-layout row wrap>
                      <v-flex xs6 sm6 md6 shrink>
                        <v-tooltip bottom>
                          <v-btn
                            icon
                            medium
                            slot="activator"
                            flat
                            @click="git(item)"
                          >
                            <v-icon color="info" medium>search</v-icon>
                          </v-btn>
                          <span>{{ $t('Details') }}</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-hover>
          </v-flex>
        </v-container>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import auth from "@/api/auth.js";
import logoo from "../../../../assets/control";

export default {
  data() {
    return {
       firmaBilgileri:null,
      bookingUserName:'',
      bookingUserPassword:'',
      ActiveType:false,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      searchParams: {
        SessionHeader: {
          SessionId: "",
          SessionToken: "",
        },
        InsertStartDate: null,
        InsertEndDate: null,
        Status: "PreBooked", //Preboked
        ProviderType: "Air",
        TopTake: false,
      },
      ticketList: [],
      statusItems: [
        {
          text: this.$t('Pre-Reservation'),
          value: "PreBooked",
        },
        {
          text: this.$t('Ticket'),
          value: "Booked",
        },
      ],
    };
  },
  methods: {
     async addAgency2()
    {
      this.loadingvmodel = true;
 var credentials = JSON.parse(window.localStorage.getItem("credentials"));

var params={
  Name:credentials.CoperSirketAdi,
  City:this.firmaBilgileri.City,
  District:this.firmaBilgileri.District,
  CountryCode:"TR",
  Address:this.firmaBilgileri.Address,
  Gsm:this.firmaBilgileri.Gsm,
  Email:this.firmaBilgileri.Email,
  TaxOffice:this.firmaBilgileri.TaxOffice,
  TaxNo:this.firmaBilgileri.TaxNo};

  this.$http
        .post(auth.BOOKING_API_URL + "Agency/AddAgency", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
         (response) => {
          console.log(response);
         if (response.body.Usernanme!=null)
         {
          this.bookingUserName=response.body.Username;
          this.bookingUserPassword=response.body.Password;
         }
            console.log(response);
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
              return false;
            } else {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
              return false;
            }
          }
        );
       this.loadingvmodel = false;
        return true;
       
    },
    async chkAgency() {
  this.loadingvmodel = true;
  try {
    const params = {
      Email: this.firmaBilgileri.Email,
      TaxNo: this.firmaBilgileri.TaxNo,
    };
    const response = await this.$http.post(auth.BOOKING_API_URL + 'Agency/CheckAgency', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    });
   
    if (response.body.HasError)
    {
      this.loadingvmodel = false;
       return false;
    }
    else
    {
      this.loadingvmodel = false;
          this.bookingUserName=response.body.Username;
          this.bookingUserPassword=response.body.Password;
          return true;
    }
  } catch (error) {
    this.loadingvmodel = false;
    console.log(error);
    return false;
  }
},
    async EkurunGetir() {
  this.loadingvmodel = true;
  try {
    const params3 = {
      GrupID: null,
      UrunID: null,
      MusteriID: null
    };

    const response = await this.$http.post(auth.API_URL + 'api/Awed/ExtraProductGroupList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    });

    const ekurun = response.body[3].Aktif;

    if (!ekurun) {
      this.text1 = "Pazar Yeri Ürünü Bulunamadı";
      this.loadingvmodel = false;
      this.snackbar = true;
      return false;
    }
this.loadingvmodel = false;
    return true;
  } catch (error) {
    this.text1 = "Service Unavailable";
    this.loadingvmodel = false;
    this.snackbar = true;
    return false;
  }
},
    async FirmaBilgileriGetir() {
  this.loadingvmodel =true;
  try {
    const credentials = JSON.parse(window.localStorage.getItem("credentials"));
    const paramscompany = {
      SirketKodu: credentials.SirketKodu
    };
    const responsecompany = await this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', paramscompany, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    });

    this.firmaBilgileri = {
      Name: credentials.CoperSirketAdi,
      City: responsecompany.body.Il,
      District: responsecompany.body.Ilce,
      CountryCode: "TR",
      Address: responsecompany.body.Adres,
      Gsm: responsecompany.body.Tel,
      Email: responsecompany.body.Email,
      TaxOffice: responsecompany.body.VergiDairesi,
      TaxNo: responsecompany.body.VergiNo
    };
console.log(this.firmaBilgileri);
    if (!this.firmaBilgileri.Email || !this.firmaBilgileri.TaxNo) {
      this.text1 = "Firma Mail Adresi veya Vergi Numarası Bulunamadı";
      this.loadingvmodel = false;
      this.snackbar = true;
      return false;
    }
    this.loadingvmodel = false;
    return true;
  } catch (error) {
    this.text1 = "Service Unavailable";
    this.loadingvmodel = false;
    this.snackbar = true;
    return false;
  }
},
    async BookingKontrol() {
  const coperFirmaBilgileri = await this.FirmaBilgileriGetir();
  if (!coperFirmaBilgileri) {
    return;
  }

  const ekUrunVar = await this.EkurunGetir();
  if (!ekUrunVar) {
    return;
  }

  
  const firmaVar = await this.chkAgency();
  if (!firmaVar) {
   const firmaEklendi = await this.addAgency2();
  if (!firmaEklendi) {
    return;
  }
  }
  

  if (firmaVar || firmaEklendi)
  {
    await this.Login();
  }
  
  
},
    git(val) {
      window.localStorage.setItem("shopCartID", val.ShoppingCartId);
      var url = "#/satis/ucus/islem/id?islem=get&" + "pnr=" + val.Pnr;
      window.open(url, "_self");
    },
    getImgUrl(img) {
      return logoo.logoControl(img);
    },
    getAccountDetails() {
      this.loadingvmodel = true;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      var params = {
        CustomerID:credentials.MusteriID,
        ServiceID: 1
      };

      this.$http
        .post(auth.API_URL + "api/Booking/ServiceInfoLoad", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            auth.BOOKING_API_URL   = auth.BOOKING_API_URL;//response.body.Url;
            this.ActiveType = response.body.Active;
            this.loadingvmodel = false;
            this.getToken();
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            }
          }
        );
    },
    getList() {
      this.loadingvmodel = true;
     var bookingParams = JSON.parse(
        window.localStorage.getItem("bookingParams")
      );
    if (bookingParams==null)
    {
      this.BookingKontrol();
      return;
    }
      this.searchParams.SessionHeader.SessionId = bookingParams.SessionId;
      this.searchParams.SessionHeader.SessionToken = bookingParams.SessionToken;

      this.$http
        .post(auth.BOOKING_API_URL + "Report/Reservations", this.searchParams, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.loadingvmodel = false;
            this.ticketList = response.body.ReservationReports;
          },
          (response) => {
            if (response.status === 0) {
              this.loadingvmodel = false;
              this.text1 = "Service Unavailable-Reservations";
              this.snackbar = true;
            } else {
                            this.loadingvmodel = false;
              this.text1 = "Service Unavailable-Reservations";
              this.snackbar = true;
            }
          }
        );
    },
   async Login() {
      
      this.loadingvmodel = true;
      var params = {
        Username: "Arkgsa",
        Password: "3paPVcsbbpf5Lwj",
         IsTest: true

      };

      this.$http
        .post( auth.BOOKING_API_URL + "Login", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.loadingvmodel = false;
          //  this.ucuAraPrms.SessionHeader.SessionId=response.body.SessionId;
          //  this.ucuAraPrms.SessionHeader.SessionToken=response.body.SessionToken;
          window.localStorage.setItem(
              "bookingParams",
              JSON.stringify(response.body)
            );
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            }
          }
        );
      },
//         var credentials = JSON.parse(window.localStorage.getItem("credentials"));

// var params = {
//   CustomerID : credentials.MusteriID,
//   ServiceID : 1
// };

// this.$http
// .post(auth.API_URL + "api/Booking/Login", params, {
//   headers: {
//     Authorization: "Bearer " + auth.getAuthHeader(),
//   },
// })
// .then(
//   (response) => {
//     window.localStorage.setItem(
//       "bookingParams",
//       JSON.stringify(response.body)
//     );
//   },
//   (response) => {
//     if (response.status === 0) {
//       this.text1 = "Service Unavailable-BookingLogin";
//       this.snackbar = true;
//     } else {
//       this.text1 = "Service Unavailable-BookingLogin";
//       this.snackbar = true;
//     }
//   }
// );
//},


  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    tarihim,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
      var bookingParams = JSON.parse(
        window.localStorage.getItem("bookingParams")
      );
    if (bookingParams==null)
    {
      this.BookingKontrol();
      return;
    }
    // if (this.sayfayetki.Status == true) {
    //   YETKİ OK
      
    // } else {
    //   this.$refs.yetkidialog
    //     .open(this.sayfayetki.Message, this.sayfayetki.islem)
    //     .then((sonuc) => {
    //       if (sonuc == true) {
    //         if (this.prevRoute != null) {
    //           var url = "#" + this.prevRoute;

    //           window.open(url, "_self");
    //         } else {
    //           var mainUrl = "#/";
    //           window.open(mainUrl, "_self");
    //         }
    //       }
    //     });
    // }
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
};
</script>

<style>
</style>

